import { StyledHeader } from './UploadHeader.styled';

const UploadHeader = (): JSX.Element => {
  return (
    <StyledHeader>Загрузите документы, которые требуют подписания</StyledHeader>
  );
};

export default UploadHeader;
